import { baseAPI } from '~shared/api/base-api';

export type CheckInReportPersonType = 'student' | 'volunteer';

export interface ExportCheckInReportParams {
  recitalId: string;
  format?: 'csv' | 'pdf';
  showId?: string;
  type?: CheckInReportPersonType;
}

export interface DownloadCheckInReportFilters {
  showId?: string;
  type?: CheckInReportPersonType;
}

function buildCheckInReportFilename(
  recitalId: string,
  format: 'csv' | 'pdf',
  filters?: DownloadCheckInReportFilters,
): string {
  const datePart = new Date().toISOString().slice(0, 10);
  const segments = ['check-in-report', recitalId];
  if (filters?.type) {
    segments.push(filters.type);
  }
  if (filters?.showId) {
    segments.push('show');
  }
  segments.push(datePart);
  return `${segments.join('-')}.${format}`;
}

export const exportCheckInReport = async ({
  recitalId,
  format = 'csv',
  showId,
  type,
}: ExportCheckInReportParams): Promise<Blob> => {
  try {
    const response = await baseAPI.get(
      `/recitals/${recitalId}/reports/check-ins`,
      {
        params: { format, showId, type },
        responseType: 'blob',
      },
    );
    return response.data;
  } catch (error) {
    console.error('Failed to export check-in report', { recitalId, format, error });
    throw error;
  }
};

export const downloadCheckInReport = async (
  recitalId: string,
  format: 'csv' | 'pdf' = 'csv',
  filters?: DownloadCheckInReportFilters,
): Promise<void> => {
  const blob = await exportCheckInReport({
    recitalId,
    format,
    showId: filters?.showId,
    type: filters?.type,
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = buildCheckInReportFilename(recitalId, format, filters);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
